export const COMMUNICATION_PREFERENCES_FORM = 'communicationPreferencesForm'

export const CALL_ME_PREFERENCE = 'callMe'

export const REMINDERS_FIELD = 'reminders'

export const PROMOTIONS_FIELD = 'promotions'
